import $ from 'jquery';

import 'slick-carousel';

let zenitech = {
	init() {
		//Home Slider
		if($('.paragraph--type--bloc-slider-large-accueil:not(.slick-slider)').length) {
			$('.paragraph--type--bloc-slider-large-accueil:not(.slick-slider)').slick({
				arrows : false,
				dots: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				autoplay: true,
				autoplaySpeed: 5000,
				adaptiveHeight: true,
			})
		}
	}
}

export default zenitech;






